import axios from 'axios';
import qs from 'qs';
import {
    utilizeCancelToken,
    checkResponseVersion,
    finalizeResponse,
    handleError
} from 'tradera-utils/api';

/**
 *
 * @param {string} endpoint
 * @param {object} params
 * @param {string} baseURL
 * @param version
 * @returns {Promise<*>}
 */
export const getSearchResults = async (
    endpoint,
    params,
    baseURL = '',
    version
) => {
    if (!params) {
        if (process && process.env && process.env.NODE_ENV !== 'production') {
            console.warn(
                'getSearchResults must have queryParams as the first argument'
            );
        }
        return;
    }

    const { cancel, cancelToken } = utilizeCancelToken('fetchCategoryList');
    if (cancel) cancel();

    return axios
        .get(`${endpoint}.json`, {
            cancelToken,
            baseURL,
            params,
            paramsSerializer: function(params) {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
        })
        .then(version ? checkResponseVersion(version) : response => response)
        .then(finalizeResponse())
        .catch(handleError());
};
